const INCLUDES = [
  { icon: 'ri-stack-line', label: 'Металлический каркас', desc: 'Профильная труба, рассчитанная под снеговую и ветровую нагрузку' },
  { icon: 'ri-shield-check-line', label: 'Изготовление', desc: 'Резка, сварка, зачистка швов и сборка конструкции в цеху' },
  { icon: 'ri-paint-brush-line', label: 'Покраска', desc: 'Антикоррозийная обработка, грунтовка, покраска в цвет по RAL' },
  { icon: 'ri-truck-line', label: 'Доставка', desc: 'Бережная транспортировка до вашего участка' },
  { icon: 'ri-tools-fill', label: 'Монтаж', desc: 'Установка на подготовленное основание, крепление и финишная проверка' },
];

const DURABILITY = [
  {
    icon: 'ri-hard-drive-2-line',
    title: 'Прочный каркас',
    desc: 'Используем профильную трубу с запасом прочности. Каркас выдерживает снеговую нагрузку до&nbsp;200&nbsp;кг/м² — в&nbsp;2 раза выше норматива для&nbsp;региона.',
  },
  {
    icon: 'ri-calculator-line',
    title: 'Расчёт нагрузок',
    desc: 'Каждый проект просчитываем индивидуально: снеговая нагрузка, ветровое давление, угол ската. Без&nbsp;«на глаз» — только цифры.',
  },
  {
    icon: 'ri-shield-flash-line',
    title: 'Антикоррозийная защита',
    desc: 'Металл проходит двухэтапную обработку: цинковый грунт и&nbsp;полимерно-порошковое покрытие. Конструкция не&nbsp;ржавеет 15+&nbsp;лет.',
  },
  {
    icon: 'ri-palette-line',
    title: 'Покрытие и цвет по RAL',
    desc: 'Порошковая покраска на выбор: любой цвет по каталогу RAL. Покрытие устойчиво к&nbsp;ультрафиолету, не&nbsp;выгорает и&nbsp;не&nbsp;шелушится.',
  },
];

export default function WhySection() {
  return (
    <>
      {/* What's included */}
      <section className="py-16 md:py-20 bg-background-50">
        <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
          <div className="text-center mb-12 md:mb-16">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              Что входит в заказ
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              Прозрачная смета — вы точно знаете, что&nbsp;получаете
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
            {INCLUDES.map((item, idx) => (
              <div
                key={item.label}
                className="text-center group animate-fade-in-up"
                style={{ animationDelay: `${idx * 0.1}s` }}
              >
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-400">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1.5">{item.label}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Durability */}
      <section className="py-16 md:py-20 bg-background-100">
        <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
          <div className="text-center mb-12 md:mb-16">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              Почему конструкция прослужит долго
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              Четыре причины, по которым наш навес стоит десятилетиями без&nbsp;ремонта
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {DURABILITY.map((item, idx) => (
              <div
                key={item.title}
                className="flex items-start gap-5 bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-7 transition-all duration-400 hover:border-primary-200/50 animate-fade-in-up"
                style={{ animationDelay: `${idx * 0.1}s` }}
              >
                <div className="shrink-0 w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: item.desc }}></p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}